function c(o, i, s) {
  const t = "hobi-visually-hidden", r = {
    behavior: "smooth",
    block: "start",
    inline: "start"
  }, n = "scrollBehavior" in document.documentElement.style ? i || r : !0;
  if (!o) {
    console.error(
      `[scrollIntoView]: scrollIntoView requires element to be an HTMLElement and got NULL
    Most likely you have a validation error on the current form and the errors are not being shown
    The fields with errors are:`,
      s
    );
    return;
  }
  o != null && o.classList.contains(t) ? (o == null || o.classList.remove(t), o.scrollIntoView(n), setTimeout(() => {
    o == null || o.classList.add(t);
  }, 0)) : o.scrollIntoView(n);
}
const e = (o) => function(s) {
  s.isIntersecting || (console.log(
    o,
    `is Intersecting - ${s.isIntersecting} - intersectionRatio: ${s.intersectionRatio}`
  ), c(o, { behavior: "smooth", block: "end" }));
}, l = (o) => function(s) {
  s.forEach((t) => {
    o(t);
  });
};
function a(o, i, s) {
  const t = l(i), r = new IntersectionObserver(t, s);
  return r.observe(o), r;
}
const u = (o) => o.disconnect();
function h() {
  return {
    scrollIntoView: c,
    createScrollIfNotVisibleCb: e,
    observeElemement: a,
    disconnectObserver: u
  };
}
export {
  h as useScrollTo
};
